import { Button, Modal } from '@iwoca/orion';
import styles from './FirstAppModal.module.css';

type TProps = {
  triggerTour: () => void;
  showModal: boolean;
  closeModal: () => void;
};

export const FirstAppModal = ({
  triggerTour,
  showModal,
  closeModal,
}: TProps) => {
  return (
    <Modal
      className={styles.modal}
      isOpen={showModal}
      onClose={closeModal}
      title="You've successfully created your first application! 🎉"
    >
      <p className={styles.text}>
        Start exploring dashboard features to help manage your applications more
        efficiently.
      </p>
      <Button
        className={styles.button}
        onClick={() => {
          closeModal();
          /* TODO: https://iwoca.atlassian.net/browse/BAE-3058 PUT to tutorials to mark as complete so we dont show modal again */
          triggerTour();
        }}
      >
        Take the tour
      </Button>

      <Button
        className={styles.secondaryButton}
        variant="tertiary"
        /* TODO: https://iwoca.atlassian.net/browse/BAE-3058 PUT to tutorials to mark as complete so we dont show modal again */
        onClick={closeModal}
      >
        Maybe later
      </Button>
    </Modal>
  );
};
